import { FC } from 'react';
import documentTypes from 'constants/documentTypes';
import DefaultList from '../components/DefaultList/DefaultList';

export const documentsListMap: Record<string, FC> = {
  [documentTypes.ALL]: DefaultList,
  [documentTypes.MYFOLDERS]: DefaultList,
};
